// @flow

import React from "react";
import { localize } from "redux-i18n";

import actionCreators from "@modules/employee/actionCreator";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, SchemaForm, View } from "@components";

type OwnProps = $Exact<{
  clientId: number,
  title: string,
  onCancel: () => void,
  onSubmit: (formData: Object) => void,
  disableAdd?: boolean,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class AddFileAttachmentModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    if (this.formRef) {
      this.formRef.current.submit();
    }
  };

  handleSubmit = (form: Object) => {
    this.props.onSubmit(form);
  };

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader className="d-flex justify-content-between" toggle={this.props.onCancel}>
          {this.props.t(this.props.title)}
        </ModalHeader>
        <ModalBody>
          <View padding="0.5rem 1rem">
            <SchemaForm
              ref={this.formRef}
              schema={{
                type: "object",
                required: ["file"],
                properties: {
                  file: {
                    type: "string",
                    title: "File",
                    format: "data-url",
                  },
                },
              }}
              uiSchema={{
                "ui:order": ["file"],
                file: {
                  "ui:title": "Select File",
                },
              }}
              data={{}}
              onSubmit={this.handleSubmit}
              externalSubmit
            />
          </View>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.props.onCancel}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="add_box" disable={this.props.disableAdd} onClick={this.submitForm}>
            {this.props.t("ADD")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(AddFileAttachmentModal);
